import { memo } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { EditorUnknownType } from './RuleEditor';
import { RuleEditorContainerBox } from './RuleEditorContainer.style';

export const RuleEditorContainer = memo(({ children }) => {
    const { type } = useParams<{ type: string }>();

    if (!type || type === 'Rule' || type === 'NonEditableRule') {
        return <EditorUnknownType type={type} />;
    }

    return (
        <RuleEditorContainerBox>
            {children}
            <Outlet />
        </RuleEditorContainerBox>
    );
});
